const TERM_AGREED_KEY = 'termAgreement';

export function setTermAsAgreed(): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(TERM_AGREED_KEY, 'true');
}

export function clearTermsAgreed(): void {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(TERM_AGREED_KEY);
}

export function hasTermAgreed(): boolean {
  if (typeof window === 'undefined') return false;
  return localStorage.getItem(TERM_AGREED_KEY) === 'true';
}
